import { render, staticRenderFns } from "./shopItem.vue?vue&type=template&id=36987c3c&"
import script from "./shopItem.vue?vue&type=script&lang=js&"
export * from "./shopItem.vue?vue&type=script&lang=js&"
import style0 from "./shopItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports